<app-nav></app-nav>

<div class="content">
  <section class="contact-section">

    <header class="contact-header">
      <span class="badge">Soporte</span>
      <h2>¿En qué te ayudamos?</h2>
      <p>Describe tu problema y nuestro equipo de soporte te responderá en breve</p>
    </header>

    <!-- ── CATEGORY CHIPS ── -->
    @if (status() !== 'success') {
      <div class="category-chips">
  @for (cat of categories; track cat.value) {
    <button
      type="button"
      class="chip"
      [class.active]="selectedCategory() === cat.value"
      (click)="selectCategory(cat.value)"
    >
      <i [class]="cat.icon"></i>
      {{ cat.label }}
    </button>
  }
</div>
    }

    <!-- ── SUCCESS STATE ── -->
    @if (status() === 'success') {
      <div class="feedback-box success">
        <div class="feedback-icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#12916B" stroke-width="1.5"/>
            <path d="M8 12l3 3 5-5" stroke="#12916B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h3>¡Ticket creado!</h3>
        <p>Recibimos tu solicitud de soporte. Nuestro equipo revisará tu caso y te responderá en un plazo de <strong>24 horas hábiles</strong>.</p>
        <button class="btn-feedback" (click)="resetStatus()">Abrir otro ticket</button>
      </div>
    }

    <!-- ── ERROR STATE ── -->
    @if (status() === 'error') {
      <div class="feedback-box error">
        <div class="feedback-icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#DC3545" stroke-width="1.5"/>
            <path d="M12 8v4M12 16h.01" stroke="#DC3545" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <h3>Algo salió mal</h3>
        <p>No pudimos enviar tu solicitud. Intenta de nuevo o escríbenos directamente a <strong>tripgoservice&#64;gmail.com</strong></p>
        <button class="btn-feedback" (click)="resetStatus()">Intentar de nuevo</button>
      </div>
    }

    <!-- ── FORM ── -->
    @if (status() !== 'success') {
      <form class="contact-form" [formGroup]="supportForm" (ngSubmit)="onSubmit()">

        <div class="form-row">

          <div class="form-group" [class.has-error]="fullName.invalid && fullName.touched">
            <input
              type="text"
              id="fullName"
              formControlName="fullName"
              placeholder=" "
              autocomplete="name"
            >
            <label for="fullName">Nombre completo</label>
            @if (fullName.invalid && fullName.touched) {
              <span class="field-error">Ingresa tu nombre</span>
            }
          </div>

          <div class="form-group" [class.has-error]="email.invalid && email.touched">
            <input
              type="email"
              id="email"
              formControlName="email"
              placeholder=" "
              autocomplete="email"
            >
            <label for="email">Correo electrónico</label>
            @if (email.invalid && email.touched) {
              <span class="field-error">Ingresa un correo válido</span>
            }
          </div>

        </div>

        <div class="form-group" [class.has-error]="subject.invalid && subject.touched">
          <input
            type="text"
            id="subject"
            formControlName="subject"
            placeholder=" "
          >
          <label for="subject">Asunto del problema</label>
          @if (subject.invalid && subject.touched) {
            <span class="field-error">Describe brevemente el asunto</span>
          }
        </div>

       <div class="priority-group">
  <label class="static-label">Prioridad</label>
  <div class="priority-options">
    @for (p of priorities; track p.value) {
      <button
        type="button"
        class="priority-pill"
        [class.selected]="selectedPriority() === p.value"
        (click)="selectPriority(p.value)"
      >
        <span class="dot" [style.background]="p.color"></span>
        {{ p.label }}
      </button>
    }
  </div>
</div>

        <div class="form-group" [class.has-error]="description.invalid && description.touched">
          <textarea
            id="description"
            rows="5"
            formControlName="description"
            placeholder=" "
          ></textarea>
          <label for="description">Describe el problema con detalle</label>
          @if (description.invalid && description.touched) {
            <span class="field-error">Por favor describe el problema (mínimo 20 caracteres)</span>
          }
        </div>

        <button
          type="submit"
          class="btn-primary"
          [disabled]="supportForm.invalid || status() === 'loading'"
          [class.loading]="status() === 'loading'"
        >
          @if (status() === 'loading') {
            <span class="spinner"></span>
            Enviando ticket...
          } @else {
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M22 2L11 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M22 2L15 22l-4-9-9-4 20-7z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Enviar ticket de soporte
          }
        </button>

      </form>
    }

    <div class="contact-info">
      <h3>Otros canales de soporte</h3>
      <i class="fa-solid fa-envelope"></i> <a href="mailto:tripgoservice@gmail.com" target="_blank">
        tripgoservice@gmail.com
      </a>
      <p> <i class="fa-solid fa-comments"></i> Chat en vivo: Lun–Vie, 8 am – 6 pm</p>
      <p> <i class="fa-solid fa-phone"></i>+57 3147212090</p>
    </div>

  </section>
</div>

<app-footer></app-footer>
